<template>
  <v-dialog persistent :value="detailModal" width="500">
    <v-card>
      <popup-heading 
      :title="detailObj.display_name" 
      :subtitle="'Platform links for ' + detailObj.display_name">
        <template slot="action">
          <v-btn
            depressed
            @click="closeModal()"
            fab 
            color="white"
            :class="$vuetify.breakpoint.width > 960 ? 'ml-0' : 'ml-2'"
          >
            <v-icon dark class="primary--text">close</v-icon>
          </v-btn>
        </template>
      </popup-heading>
       <v-card-text class="pa-5" v-if="!loaded">
          <block-spinner ></block-spinner>
       </v-card-text>
        <v-card-text class="pa-5" v-else>
          <img v-if="appDetail.image_url" class="mb-2 detail-img" :src="appDetail.image_url" alt=""/>
         <table class="normal-table" width="100%">
           <tr>
             <td>Name</td>
             <td>{{ appDetail.appDetail ? appDetail.display_name : '' }}</td>
           </tr>
           <tr>
             <td>Web link</td>
             <td>{{ appDetail.appDetail ? appDetail.appDetail.web_link : '' }}</td>
           </tr>
           <tr>
             <td>IOS link</td>
             <td>{{ appDetail.appDetail ? appDetail.appDetail.ios_link : '' }}</td>
           </tr>
           <tr>
             <td>Android link</td>
             <td>{{ appDetail.appDetail ? appDetail.appDetail.android_link : '' }}</td>
           </tr>
         </table>
        </v-card-text>
      </v-card>
    </v-dialog>
</template>
<script>
import Env from '@/env';
import AuthApi from '@/components/Controllers/AuthApis';
import Helper from '@/components/Controllers/Helpers';
import { mapActions, mapGetters } from 'vuex';
import { isEmpty } from 'lodash';

export default {
  data() {
    return {
      loaded: true,
      appDetail: {},
    };
  },
  computed: {
    ...mapGetters({
      detailModal: 'application/detail',
      detailObj: 'application/detailObj',
    }),
  },

  watch: {
    detailObj(val) {
      // if there is obj data 
      if(!_.isEmpty(val)) {
        this.getAppDetail(val.id);
      }
    }
  },

  mounted() {
    this.closeModal();
  },
  methods: {

    /**
     * Fetch all app list
     */
    getAppDetail(appId) {
      this.loaded = false;
      const url = `${Env.url}/api/v1/apps/${appId}`;
      AuthApi.getApi(url)
        .then((res) => {
          this.loaded = true;
          this.appDetail = res.data.payload;
        })
        .catch((err) => {
          this.spinner(false);
          this.loaded = true;
          this.snackbar({
            text: err.response.data.msg ? err.response.data.msg : 'App not found.',
            timeout: 4000,
            open: true,
          });
        });
    },

    /**
     * Close update modal and remove assign values in form
     */
    closeModal() {
      this.setDetail(false);
      this.setDetailObj({})
      this.appDetail = {};
    },

    ...mapActions({
      setDetail: 'application/setDetail',
      setDetailObj: 'application/setDetailObj',
      spinner: 'spinner/spinnerStatus',
      snackbar: 'snackbar/snackbar',
    }),
  },
};
</script>
